import { Injector, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Page } from '../models/page.model';
import { Planejamento } from '../models/planejamento.model';
import { Equipe } from '../models/equipe.model';
import { Gestao } from '../models/gestao.model';
import { PriceResumo } from '../models/price-resumo.model';
import { Erf } from '../models/erf.model';

@Injectable({
    providedIn: 'root'
})
export class CalculoService {
    protected http: HttpClient;

    constructor(
        protected injector: Injector) {
        this.http = injector.get(HttpClient);
    }

    calcularParametroFormacaoPrecosPlaneja(valor: number, campo: string, estimativaId: number): Observable<any> {
        return this.http.get<Page<Planejamento>>(`${environment.API_PRICE}/calculo/calcularParametroFormacaoPrecosPlaneja/${valor}/${campo}/${estimativaId}`);
    }

    calcularTotalCusto(estimativaId: number, totalProjeto: number, gestao: number, campo: string): Observable<any> {
        return this.http.get<Page<Equipe>>(`${environment.API_PRICE}/calculo/CalcularTotalCusto/${estimativaId}/${totalProjeto}/${gestao}/${campo}`);
    }

    calcularParametroFormacaoPrecosGestao(valor1: number, valor2: number, campo: string): Observable<any> {
        return this.http.get<Page<Gestao>>(`${environment.API_PRICE}/calculo/calcularParametroFormacaoPrecosGestao/${valor1}/${valor2}/${campo}`);
    }

    calcularPricing(estimativaId: number, receitaBrutaAdotado?: number): Observable<any> {
        return this.http.get<Page<PriceResumo>>(`${environment.API_PRICE}/calculo/calcularPricing/${estimativaId}/${receitaBrutaAdotado}`);
    }

    calcularSimulacao(estimativaId: number): Observable<any> {
        return this.http.get<Page<PriceResumo>>(`${environment.API_PRICE}/calculo/calcular-mao-de-obra-colaboradores/${estimativaId}`);
    }

    calcularReceitaBrutaAdotado(estimativaId: number): Observable<number> {
        return this.http.get<number>(`${environment.API_PRICE}/calculo/calcularReceitaBrutaAdotado/${estimativaId}`);
    }

    calcularErfPlaneja(planeja: Planejamento): Observable<Planejamento> {
        return this.http.post<Planejamento>(`${environment.API_PRICE}/calculo/calcular-erf-planeja`, planeja);
    }

    calcularErfGestao(gestao: Gestao, planejaCol?: number): Observable<any> {
        return this.http.post<Gestao>(`${environment.API_PRICE}/calculo/calcular-erf-gestao`, gestao);
    }

    calcularErf(erf: Erf): Observable<Erf> {
        return this.http.post<Erf>(`${environment.API_PRICE}/calculo/calcular-erf`, erf);
    }

    calcularMaoDeObraDireta(equipe: Equipe): Observable<number> {
        return this.http.post<number>(`${environment.API_PRICE}/calculo/calcular-mao-obra-direta`, equipe);
    }

    calcularQuantidadeHorasAdotado(estimativaId: number): Observable<number> {
        return this.http.get<number>(`${environment.API_PRICE}/calculo/calcular-quantidadeHoras-adotado/${estimativaId}`);
    }

    calcularProvisaoRiscoByReceitaBruta(estimativaId: number, receitaBruta: number): Observable<any> {
        return this.http.get<number>(`${environment.API_PRICE}/calculo/calculaProvisaoRiscoByReceitaBruta/${estimativaId}/${receitaBruta}`);
    }
}
